
export const REQUEST_DELETEVIDEOCLIP= 'REQUEST_DELETEVIDEOCLIP';
export const DELETEVIDEOCLIP_RECEIVED = 'DELETEVIDEOCLIP_RECEIVED';
export const CLEAR_DELETEVIDEOCLIP = 'CLEAR_DELETEVIDEOCLIP';